// extracted by mini-css-extract-plugin
export default {"question":"Input_question__+2uxx","span":"Input_span__zsxD9","error-msg":"Input_error-msg__ZjEkL","appear":"Input_appear__gNiVp"};